import React from "react";
import { BooleanDisplayProps, DisplayProps } from "models/propTypes/wintFormPropsTypes";
import { LocalizationHelperInstance } from "utils/helpers";
import ReadOnlyField from "../../forms/baseFields/readOnlyField";
import cssExports from "theme/styles/main.module.scss";
import { TranslationKeys } from "translations";

const BooleanDisplay: React.FC<DisplayProps> = (props: BooleanDisplayProps) => {
  return (
    <ReadOnlyField label={props.label} href={props.href} className={cssExports.readOnlyTextField}>
      {props.value
        ? props.customLabels?.active ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Yes)
        : props.customLabels?.inactive ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.No)}
    </ReadOnlyField>
  );
};

export default BooleanDisplay;
